/**
 * Created by litao on 2018/10/15.
 */
export default (http) => {
    return {
        /**
         * 用户登录
         * @param data
         * @return {*}
         */
        login(data) {
            return http.json({
                url: '/login',
                data: Object.assign(data || {}, {
                    adminFlag: 'liTaoXWB'
                })
            })
        },

        /**
         * 获取当前登录用户
         * @return {*}
         */
        getCurrentUser() {
            return http({
                url: '/sys/account/info',
                method: 'post'
            });
        },
        deleteBySchool() {
            return http({
                url: '/sys/account/deleteBySchool',
                method: 'post'
            });
        },

        modifyField(data) {
            return http({
                method: 'post',
                url: `/sys/account/modifyField?fieldName=${data.fieldName}&fieldValue=${data.fieldValue}`
            })
        },

        queryAll(data) {
            return http.json({
                url: '/sys/account/queryAll',
                data
            })
        },
        queryAllWithJifen(data) {
            return http.json({
                url: '/sys/account/queryAllWithJifen',
                data
            })
        },

        queryAllWareHouseManager(data) {
            return http.json({
                url: '/sys/account/queryAllWareHouseManager',
                data
            })
        },


        modifyPassword(data) {
            return http.json({
                url: '/sys/account/modifyPassword',
                data
            })
        },

        /**
         * 获取当前登录用户
         * @return {*}
         */
        queryUserWarranty(data) {
            return http.json({
                url: '/sys/account/queryUserWarranty',
                data
            })
        },

        getInfo(data) {
            return http.json({
                url: '/sys/account/getOne',
                data
            });
        },
        updatePassword(data) {
            return http.json({
                url: '/sys/account/resetPassword',
                data
            });
        },
        resetTeaPassword(data) {
            return http.json({
                url: '/sys/account/resetTeaPassword',
                data
            });
        },

        /**
         * 用户登录
         * @param data
         * @return {*}
         */
        h5login(data) {
            return http.json({
                url: '/login',
                data: Object.assign(data || {}, {
                })
            })
        },

        getUserByCode(data) {
            return http.json({
                url: '/oauth/getUserByCode',
                data
            })
        },

    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/user.js